import React, {useState, useEffect, useRef} from 'react';
import Button from 'react-bootstrap/Button';
import {showToast} from '../../common/app_common.js';
import {BadgeChange, useBlockerWithModal} from '../../common/component_common.js';
import {getApiConfigSystem, postApiConfigSystem} from '../../common/fetch_api/configuration';
import {DecideWindow} from '../../common/modal_common.js';

export const View = ({existUpdate, setExistUpdate}) => {

    // KOR {lat: 35.9500, lng: 128.0000, zoom: 6.30};
    // USA {lat: 38.1000, lng: -97.7000, zoom: 4.10};

    const [update, setUpdate] = useState(false);
    const [systemInfo, setSystemInfo] = useState({
        systemName: '',
        hostUrl: '',
        latitude: 0,
        longitude: 0,
        zoom: 0,
        style: 'Streets',
        locationOffset: 0,
        markerSize: 1,
        edgeZoom: 1,
        country: '',
        mapboxToken: '',
        repeatIntervalHour: 0,
        sendResolved: false,
        defaultEndpoint: '',
        diskUsagePercent: 0,
        bugReport: false
    });
    const [systemOrg, setSystemOrg] = useState({
        systemName: '',
        hostUrl: '',
        latitude: 0,
        longitude: 0,
        zoom: 0,
        style: 'Streets',
        locationOffset: 0,
        markerSize: 1,
        edgeZoom: 1,
        country: '',
        mapboxToken: '',
        repeatIntervalHour: 0,
        sendResolved: false,
        defaultEndpoint: '',
        diskUsagePercent: 0,
        bugReport: false
    });

    const onChangeSystem = (e, index) => {
        let value = e.target.value;
        
        // sendResolved와 bugReport 필드의 경우 boolean으로 변환
        if (index === 'sendResolved' || index === 'bugReport') {
            value = value === 'true' || value === true;
        }
        
        setSystemInfo((prevState) => { return { ...prevState, [index]: value } } );
    }

    const onClickSave = () => {
        let sendData = 
        {
            "systemName": systemInfo.systemName,
            "hostUrl": systemInfo.hostUrl,
            "map": {
                "latitude": parseFloat(systemInfo.latitude),
                "longitude": parseFloat(systemInfo.longitude),
                "zoom": systemInfo.zoom,
                "style": systemInfo.style,
                "locationOffset": parseFloat(systemInfo.locationOffset),
                "markerSize": systemInfo.markerSize,
                "edgeZoom": systemInfo.edgeZoom,
                "country": systemInfo.country,
                "mapboxToken": systemInfo.mapboxToken
            },
            "serverStatusAlert": {
                "diskUsagePercent": systemInfo.diskUsagePercent
            },
            "alert": {
                "repeatIntervalHour": parseFloat(systemInfo.repeatIntervalHour),
                "sendResolved": systemInfo.sendResolved,
                "defaultEndpoint": systemInfo.defaultEndpoint
            },
            "bugReport": systemInfo.bugReport
        };

        Promise.resolve( postApiConfigSystem(sendData) )
        .then( done => {
            runUpdate();
        })
    }
    
    const [modalVisible, setModalVisible] = useState(false);
    const [modalCallback, setModalCallback] = useState(null);

    const showModalDecideForRoute = ({ onConfirm }) => {
        setModalVisible(true);
        setModalCallback(() => onConfirm);
    };
    const closeModalDecideForRoute = () => {
        setModalVisible(false);
    };

    useBlockerWithModal(existUpdate, showModalDecideForRoute);

    // DecideWindow에서 OK 클릭 시
    const handleModalOk = (is) => {
        if( is )
        {
            setModalVisible(false);
            if (modalCallback) modalCallback();
        }
    };

    const SetDecideBodyMoveout = () => {
        return (
            <div className='text-center'>
                <p>There are unsaved changes. Are you sure you want to leave this page?</p>
            </div>
    )};

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() => {
        Promise.resolve( getApiConfigSystem() )
        .then( system => {

            if(system)
            {
                let tempSystemInfo = { ...systemInfo };
                for(const key1 of Object.keys(system))
                {
                    if(typeof(system[key1]) === 'object' && system[key1] !== null)
                    {
                        for(const key2 of Object.keys(system[key1]))
                        {
                            tempSystemInfo[key2] = system[key1][key2];
                        }
                    }
                    else
                    {
                        tempSystemInfo[key1] = system[key1];
                    }
                }

                setSystemInfo(tempSystemInfo);
                setSystemOrg(tempSystemInfo);
            }
        });
    }, [update]);

    const lintInt = (e, index, min, max) => {
        let val = parseInt(e.target.value) || min;

        if( val < min )
        {
            val = min;
        }

        if( val > max )
        {
            val = max;
        }
        
        setSystemInfo((prevState) => { return { ...prevState, [index]: val } } );
    }

    const lintFloat = (e, index, min, max) => {
        let val = parseFloat(e.target.value) || min;

        if( val < min )
        {
            val = min;
        }

        if( val > max )
        {
            val = max;
        }
        
        // setSystemInfo((prevState) => { return { ...prevState, [index]: val.toFixed(4) } } );
        setSystemInfo((prevState) => { return { ...prevState, [index]: val } } );
    }

    useEffect(() => {
        // Compare only the primitive values after normalizing types
        const normalize = (obj) => ({
            ...obj,
            latitude: Number(obj.latitude),
            longitude: Number(obj.longitude),
            zoom: Number(obj.zoom),
            locationOffset: Number(obj.locationOffset),
            markerSize: Number(obj.markerSize),
            edgeZoom: Number(obj.edgeZoom),
            diskUsagePercent: Number(obj.diskUsagePercent),
            repeatIntervalHour: Number(obj.repeatIntervalHour),
            sendResolved: Boolean(obj.sendResolved),
            bugReport: Boolean(obj.bugReport),
        });

        const current = normalize(systemInfo);
        const original = normalize(systemOrg);

        // Compare all keys
        const isChanged = Object.keys(current).some(
            key => current[key] !== original[key]
        );

        setExistUpdate(isChanged);
    }, [systemInfo]);

    return (
        <div className="tab-pane show active">
            <div className="section control-system-area">
                <div className="common-area">
                    <div className="section-title">Common</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">System Name</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={systemInfo.systemName} onChange={(e) => {onChangeSystem(e, 'systemName')}}/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Host Url</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={systemInfo.hostUrl} onChange={(e) => {onChangeSystem(e, 'hostUrl')}}/>
                        </div>
                    </div>
                </div>
                <div className="map-area">
                    <div className="section-title mt-3">Map</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Map Style</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <select className="form-select form-select-sm" value={systemInfo.style} onChange={(e) => {onChangeSystem(e, 'style')}}>
                                <option value='Streets'>Streets</option>
                                <option value='Outdoors'>Outdoors</option>
                                <option value='Light'>Light</option>
                                <option value='Dark'>Dark</option>
                                <option value='Satellite'>Satellite</option>
                                <option value='Satellite_Streets'>Satellite Streets</option>
                                <option value='Navigation_Day'>Navigation Day</option>
                                <option value='Navigation_Night'>Navigation Night</option>
                            </select>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box ">Latitude (MapCenter)</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" title={`-90, 90`} value={systemInfo.latitude}
                                onChange={(e) => {onChangeSystem(e, 'latitude')}}
                                onBlur={(e) => {lintFloat(e, 'latitude', -90, 90)}}
                            />
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box ">Longitude (MapCenter)</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" title={`-180, 180`} value={systemInfo.longitude}
                                onChange={(e) => {onChangeSystem(e, 'longitude')}}
                                onBlur={(e) => {lintFloat(e, 'longitude', -180, 180)}}
                            />
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Zoom</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <select className="form-select form-select-sm" value={systemInfo.zoom} onChange={(e) => {onChangeSystem(e, 'zoom')}}>
                                {
                                    Array.from({length:23}, (v, idx)=>idx).map( (idx) =>
                                        <option key={idx} value={idx}>{idx}</option>
                                    )
                                }
                            </select>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box ">Location Offset</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" title={`0, 100`} value={systemInfo.locationOffset}
                                onChange={(e) => {onChangeSystem(e, 'locationOffset')}}
                                onBlur={(e) => {lintFloat(e, 'locationOffset', 0, 100)}}
                            />
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Marker Size</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <select className="form-select form-select-sm" value={systemInfo.markerSize} onChange={(e) => {onChangeSystem(e, 'markerSize')}}>
                                <option value={0}>Small</option>
                                <option value={1}>Medium</option>
                                <option value={2}>Large</option>
                            </select>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Edge Zoom</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <select className="form-select form-select-sm" value={systemInfo.edgeZoom} onChange={(e) => {onChangeSystem(e, 'edgeZoom')}}>
                                {
                                    Array.from({length:23}, (v, idx)=>idx).map( (idx) =>
                                        <option key={idx} value={idx}>{idx}</option>
                                    )
                                }
                            </select>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box ">Country</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <select className="form-select form-select-sm" value={systemInfo.country} onChange={(e) => {onChangeSystem(e, 'country')}}>
                                <option value='us'>US</option>
                                <option value='kr'>KR</option>
                            </select>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box ">Mapbox Token</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={systemInfo.mapboxToken} onChange={(e) => {onChangeSystem(e, 'mapboxToken')}}/>
                        </div>
                    </div>
                </div>
                <div className="alert-area">
                    <div className="section-title mt-3">Alert</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Repeat Interval Hour</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <select className="form-select form-select-sm" value={systemInfo.repeatIntervalHour} onChange={(e) => {onChangeSystem(e, 'repeatIntervalHour')}}>
                                <option value='0'>Off (Only one)</option>
                                <option value='0.5'>0.5</option>
                                <option value='1'>1</option>
                                <option value='3'>3</option>
                                <option value='6'>6</option>
                                <option value='12'>12</option>
                                <option value='24'>24</option>
                            </select>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Send Resolved</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <select className="form-select form-select-sm" value={systemInfo.sendResolved} onChange={(e) => {onChangeSystem(e, 'sendResolved')}}>
                                <option value={false}>Off</option>
                                <option value={true}>On</option>
                            </select>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Default Endpoint</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <select className="form-select form-select-sm" value={systemInfo.defaultEndpoint} onChange={(e) => {onChangeSystem(e, 'defaultEndpoint')}}>
                                <option value='NotUsed'>NotUsed</option>
                                <option value='email'>Email</option>
                                <option value='slack'>Slack</option>
                                <option value='teams'>Teams</option>
                                <option value='telegram'>Telegram</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="server-status-area">
                    <div className="section-title mt-3">Server Status Alert</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Disk Usage Percent</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" title={`0, 100`} value={systemInfo.diskUsagePercent}
                                onChange={(e) => {onChangeSystem(e, 'diskUsagePercent')}}
                                onBlur={(e) => {lintInt(e, 'diskUsagePercent', 0, 100)}}
                            />
                        </div>
                    </div>
                </div>
                <div className="debug-area">
                    <div className="section-title mt-3">Debug</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Bug Report</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <select className="form-select form-select-sm" value={systemInfo.bugReport} onChange={(e) => {onChangeSystem(e, 'bugReport')}}>
                                <option value={true}>Enable</option>
                                <option value={false}>Disable</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="d-flex my-2">
                    <Button variant="primary" className="btn btn-sm btn-badge-change" onClick={onClickSave}>Save<BadgeChange show={existUpdate}/></Button>
                    <span className={`ms-3 mt-1 text-warning ${existUpdate?"":"d-none"}`}>There are unsaved changes. Please click the Save button to apply your changes.</span>
                </div>
            </div>
            {modalVisible&&<DecideWindow result={handleModalOk} show={modalVisible} handleClose={closeModalDecideForRoute} body={<SetDecideBodyMoveout />} okButtonTxt={'OK'}/>}
        </div>
    )
}